import { errorMeta } from './errorInfo.js';

/**
 * Avisa al backend de una falla (qué operación, de dónde viene, estatus, código
 * y el id de la petición que falló) para su log de errores de clientes. Nunca
 * envía el mensaje ni el cuerpo del error: pueden traer datos personales. Es
 * "dispara y olvida": jamás lanza ni bloquea la interfaz.
 *
 * El envío real se inyecta con configureErrorReporter(); sin él no hace nada.
 */
const DEDUP_MS = 60000;
const WINDOW_MS = 10 * 60000;
const MAX_PER_WINDOW = 10;

let sink = null;
const lastSent = new Map();
let windowStart = null;
let windowCount = 0;

export function configureErrorReporter(next) {
    sink = next;
}

function emit(key, data, now) {
    if (!sink) return;

    const previous = lastSent.get(key);
    if (previous !== undefined && now - previous < DEDUP_MS) return;

    if (windowStart === null || now - windowStart >= WINDOW_MS) {
        windowStart = now;
        windowCount = 0;
    }
    if (windowCount >= MAX_PER_WINDOW) return;

    windowCount++;
    if (lastSent.size > 100) lastSent.clear();
    lastSent.set(key, now);

    try {
        Promise.resolve(sink('client-errors', data)).catch(() => {});
    } catch {
        /* Reportar es opcional: una falla aquí no debe afectar a la interfaz. */
    }
}

export function reportClientError(operation, error, now = Date.now()) {
    const meta = errorMeta(error, new Date(now));
    emit(`${operation}|${meta.source}|${meta.status ?? ''}|${meta.code ?? ''}`, {
        operation,
        source: meta.source,
        ...(meta.status !== undefined ? { status: meta.status } : {}),
        ...(meta.code ? { error_code: meta.code } : {}),
        ...(meta.requestId ? { failed_request_id: meta.requestId } : {}),
        ...(meta.reason ? { reason: meta.reason } : {}),
    }, now);
}

/** Falla del propio código de la web (componente, promesa o script), sin detalles del error. */
export function reportAppFailure(operation, now = Date.now()) {
    emit(`${operation}|aplicacion||`, { operation, source: 'aplicacion' }, now);
}
